const APP = {
	STORES_URL: window.storesAjaxUrl ? window.storesAjaxUrl : "/assets/fake-server/stores.json",
	ADD_FAVORITE_URL: window.addToFavoriteUrl,
	DELETE_FAVORITE_URL: window.deleteFromFavoriteUrl,
	GET_FAVORITE_URL: window.getFavoritesUrl,
	ADD_COMPARE_URL: window.addToCompareUrl,
	DELETE_COMPARE_URL: window.deleteFromCompareUrl,
	GET_COMPARE_URL: window.getComparesUrl,
	CHECK_SHOW_ACTION_3_1_URL: window.checkShowAction3_1Url,
};
